import React from 'react';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

const DeleteButton = ({ onClick, disabled = false, sx = {}, ...props }) => {
  return (
    <IconButton
      color="error"
      onClick={onClick}
      disabled={disabled}
      sx={{
        '&:hover': { bgcolor: '#ffeaea' },
        borderRadius: 2,
        ...sx,
      }}
      {...props}
    >
      <DeleteIcon />
    </IconButton>
  );
};

export default DeleteButton;